import { render } from "./Repackage_edit.vue?vue&type=template&id=365f886b&scoped=true"
import script from "./Repackage_edit.vue?vue&type=script&lang=js"
export * from "./Repackage_edit.vue?vue&type=script&lang=js"

import "./Repackage_edit.vue?vue&type=style&index=0&id=365f886b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365f886b"]])

export default __exports__